<template>
    <div :style="type === 'icon' ? 'display:inline-block;float:left;' : ''">
        <i class="fas fa-question-circle" v-if="type === 'icon'" v-tooltip="{
            content: content,
            popover: {
                defaultClass: 'd-tooltip',
                defaultbaseClass: 'd-tooltip'
            }
        }"></i>
        <div style="margin-bottom:30px;" v-html="content" v-else></div>
    </div>
</template>

<script>
export default {
    props: ['identifier', 'type'],
    data () {
        return {
            content: null
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            const contentful = require('contentful')
            const client = contentful.createClient({
            // This is the space ID. A space is like a project folder in Contentful terms
            space: '3h0kg5qa88is',
            // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
            accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            })
            // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
            client
            .getEntries({
                content_type: 'budgetmodul',
                // 'fields.relation[in]': 'oekonomi.ebitda'
                'fields.identifier[in]': this.identifier
            })
            // .getEntry('4SzlILGMZwweEFr9myvbxT')
            .then(entries => {
                // this.content = entries.items[0].fields.forklaring
                if (entries.items[0].fields.content.content.length > 0) {
                    this.content = ''
                    this.content += '<div style="margin-bottom:-15px;">'
                    entries.items[0].fields.content.content.forEach(content => {
                        if (content.nodeType === 'paragraph') {
                            this.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>'
                        } else if (content.nodeType === 'unordered-list') {
                            this.content += '<ul style="padding-left:20px;margin-bottom:15px;">'
                            content.content.forEach(listItem => {
                                this.content += '<li>' + listItem.content[0].content[0].value + '</li>'
                            })
                            this.content += '</ul>'
                        }
                    })
                    this.content += '</div>'
                    this.content = this.content.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
            })
            .catch(err => console.log(err))
        }
    }
}
</script>



// WEBPACK FOOTER //
// ContentfulGuide.vue?9c486cec